import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Tutorial from "./Tutorial";
import { documentUploadUrlPublic } from "services/redux/fileUpload/action";
import { saveTutorialData } from "services/redux/tutorialQuestions/action";

const mapStateToProps = (state) => ({
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveTutorialData,
      documentUploadUrlPublic,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Tutorial);
